import React from "react";
import { isImpersonating, getImpersonationLabel, stopImpersonation } from "../Auth/impersonation";

/**
 * Vaste balk bovenaan zolang een admin/manager als een partner-gebruiker
 * ingelogd is. Toont wie er bekeken wordt en een knop om terug te schakelen
 * naar het eigen account.
 */
const ImpersonationBanner = () => {
  if (!isImpersonating()) return null;

  const label = getImpersonationLabel();

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        zIndex: 1080,
        background: "#b54708",
        color: "#fff",
        padding: "0.5rem 1rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        fontSize: "0.9rem",
      }}
    >
      <span>
        <i className="fa fa-user-secret" /> Je bekijkt de omgeving als{" "}
        <strong>{label || "partner-gebruiker"}</strong>
      </span>
      <button
        type="button"
        className="btn btn-sm btn-light"
        onClick={stopImpersonation}
      >
        Terug naar mijn account
      </button>
    </div>
  );
};

export default ImpersonationBanner;
